import Sentry from "@similarweb/sentry-logger";
import { Tooltip } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { useCopiedNotification } from "app/pages/sales-intelligence/hooks/useCopiedNotification";
import extensionManagementTrackingService from "app/pages/sales-intelligence/modules/extension-management/tracking/trackingService";

import { StyledEmailCopyButton } from "./styles";

export const EmailCell = ({ email }: { email: string }) => {
    const { isCopied, onCopy } = useCopiedNotification();

    const handleCopy = () => {
        extensionManagementTrackingService.trackCopyEmail();
        void navigator.clipboard
            .writeText(email)
            .then(onCopy)
            .catch((error: Error) => {
                Sentry.errorTracker({
                    e: error,
                    message: "Failed to copy email to clipboard",
                    level: "warning",
                });
            });
    };

    return (
        <Flex
            alignItems="center"
            gap="4px"
            width="100%"
        >
            <Box
                maxWidth="calc(100% - 30px)"
                textOverflow="ellipsis"
                overflow="hidden"
                whiteSpace="nowrap"
            >
                {email}
            </Box>
            <Tooltip content={translate(isCopied ? "si.common.copied" : "si.common.copy")}>
                <StyledEmailCopyButton
                    className="visibleOnRowHover"
                    type="flat"
                    iconName={isCopied ? "checked" : "copy-rounded"}
                    iconSize="xs"
                    data-automation="extension-governance-copy-email"
                    onClick={handleCopy}
                />
            </Tooltip>
        </Flex>
    );
};
